export default __webpack_public_path__ + "static/media/AARP.2059b1a4.svg";